import React from "react";
import "../styles/BlogStyles/BlogStyles.css";

const BlogPostDetail = () => {
  return (
    <article className="blog-detail-section py-5 bg-light">
      <div className="container bg-white p-0 rounded shadow-sm overflow-hidden content-container">
        
        {/* --- 1. Top Hero Image --- */}
        <div className="w-100">
          <img
            src="https://i.pinimg.com/736x/35/47/48/354748471cbad482eccf036d1db1a86c.jpg"
            alt="Skill Training in Chennai"
            className="img-fluid w-100 object-fit-cover"
            style={{ maxHeight: "450px" }} 
          />
        </div>

        <div className="p-4 p-lg-5">
          {/* --- 2. Main Title --- */}
          <div className="mb-4">
            <h1 className="fw-bold text-purple display-6 mb-3">
              Best Job-Oriented Skill Training in Chennai – Madhi Academy
            </h1>
          </div>

          {/* --- 3. Introduction --- */}
          <div className="blog-content text-secondary">
            <p className="mb-4 lead fs-6">
              In today’s competitive world, having the right skills is the key to career success. Whether you are a <strong>student, job seeker, or working professional</strong>, upgrading your skills can open the door to better opportunities. At <strong>Madhi Academy, Chennai</strong>, we provide <strong>career-focused training programs</strong> in <strong>ERP, Computer Courses, and English Communication</strong> designed to make you job-ready.
            </p>

            {/* --- 4. Why Choose Madhi Academy --- */}
            <h4 className="fw-bold text-purple mb-4 mt-5">Why Choose Madhi Academy?</h4>
            <p className="mb-3 fst-italic">If you are searching for the <strong>best skill training institute in Chennai</strong>, Madhi Academy stands out because we offer:</p>
            
            <div className="benefit-list mb-5">
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-briefcase text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Industry-Relevant Courses</h6><p className="mb-0 small text-muted">Training that matches what employers need today.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-laptop text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Hands-On Learning</h6><p className="mb-0 small text-muted">Real-world practice, not just theory.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-people text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Small Batch Size</h6><p className="mb-0 small text-muted">Personal attention to every learner.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-clock text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Flexible Timings</h6><p className="mb-0 small text-muted">Weekday & weekend batches available.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-wallet2 text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Affordable Fees</h6><p className="mb-0 small text-muted">With easy installment options.</p></div>
              </div>
            </div>
            
            <div className="bg-light p-3 border-start border-4 border-purple rounded mb-5">
              <p className="mb-0 fw-bold text-dark text-center">Our goal is simple: Upgrade Your Skills. Unlock Your Potential.</p>
            </div>

            {/* --- 5. ERP Training --- */}
            <h4 className="fw-bold text-purple mb-4">ERP Training in Chennai – Learn the Tools of Modern Business</h4>
            <p className="mb-3">ERP (Enterprise Resource Planning) systems are essential for managing business operations. Our <strong>ERP Training in Chennai</strong> covers:</p>
            <ul className="mb-4 custom-list">
              <li><strong>Tally Prime</strong> for Accounting & GST.</li>
              <li><strong>Zoho Books & QuickBooks</strong> for Cloud Accounting.</li>
              <li>Inventory, Payroll & Compliance Modules.</li>
              <li>Practical business case studies.</li>
            </ul>
            <p className="mb-5 small text-muted fst-italic">With ERP skills, you become a valuable asset in finance, accounts, and business management roles.</p>

            {/* --- 6. Computer Courses --- */}
            <h4 className="fw-bold text-purple mb-4">Computer Courses in Chennai – From Basics to Advanced</h4>
            <p className="mb-3">Every job today requires strong computer knowledge. Our <strong>Computer Courses in Chennai</strong> help you gain confidence in digital skills:</p>
            <ul className="mb-4 custom-list">
              <li>MS Office Suite (Word, Excel, PowerPoint).</li>
              <li>Email & Internet Essentials.</li>
              <li>File Management & Cloud Storage.</li>
              <li>Cybersecurity Basics.</li>
            </ul>
            <p className="mb-5 small text-muted fst-italic">This course is perfect for beginners, school/college students, and professionals who want to strengthen their computer foundation.</p>

            {/* --- 7. English Communication --- */}
            <h4 className="fw-bold text-purple mb-4">English Communication Classes in Chennai – Speak with Confidence</h4>
            <p className="mb-3">Good communication skills give you the edge in interviews and workplaces. Our <strong>English Communication Classes in Chennai</strong> focus on:</p>
            <ul className="mb-4 custom-list">
              <li>Grammar & Vocabulary Development.</li>
              <li>Spoken English Practice.</li>
              <li>Business Email & Report Writing.</li>
              <li>Public Speaking & Group Discussions.</li>
            </ul>
            <p className="mb-5 small text-muted fst-italic">By the end of this program, you’ll feel more confident in presentations, meetings, and daily conversations.</p>

            {/* --- 8. Corporate Training --- */}
            <div className="p-4 bg-light rounded mb-5">
              <h4 className="fw-bold text-purple mb-3">Corporate Training in Chennai – Customized for Companies</h4>
              <p className="mb-0 text-dark">
                We also offer <strong>corporate training programs in Chennai</strong> to upgrade employees’ ERP, computer, and communication skills. Our customized solutions ensure that your workforce is more efficient, confident, and productive.
              </p>
            </div>

            {/* --- 9. Admissions Open (Footer) --- */}
            <div className="border-top pt-4 mt-5">
              <h4 className="fw-bold text-purple mb-3 text-center">Admissions Open – Start Learning Today</h4>
              
              <div className="row justify-content-center">
                <div className="col-md-8 text-center bg-white border p-3 rounded shadow-sm">
                  <ul className="list-unstyled text-start d-inline-block">
                    <li className="mb-2"><strong className="text-dark">Eligibility:</strong> Open to 8th standard students, graduates, job seekers & professionals</li>
                    <li className="mb-2"><strong className="text-dark">Duration:</strong> Short-term & long-term programs</li>
                    <li className="mb-2"><strong className="text-dark">Fee Structure:</strong> Affordable with installment plans available</li>
                  </ul>
                </div>
              </div>

              <div className="text-center mt-4">
                <a href="tel:+917708941960" className="btn btn-sm btn-purple px-3 me-2 mb-2">
                  <i className="bi bi-telephone-fill me-1"></i> +91 77089 41960
                </a>
                <a href="mailto:admission@madhiacademy.com" className="btn btn-sm btn-purple px-3 mb-2">
                  <i className="bi bi-envelope-fill me-1"></i> admission@madhiacademy.com
                </a>
                <p className="mt-3 text-muted small">
                  Visit us at <strong>Madhi Academy, Nammalwarpet, Chennai, India</strong>
                </p>
              </div>
              
              <p className="text-center mt-3 small text-muted fst-italic">
                If you are looking for <strong>job-oriented training in Chennai</strong>, Madhi Academy is the right place to <strong>learn, grow, and succeed</strong>.
              </p>
            </div>

          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPostDetail;